/** @format */

module.exports = {
	newChallenge: "New challenge!",
	instructions:
		"You have a special mission waiting for you! Accepting to do the special mission, if you get all activities right, you will earn two extra coins and double points. But be careful, if you miss at least one activity, you will not gain anything from this mission.",
	accept: "I accept the challenge!",
	deny: "I do not want.",
};
